import { ArrowLeft, Home } from "lucide-react";

/* Phones / installed app have no browser back button — standalone pages get a clear way back. */
export const isPhone = () => window.matchMedia("(max-width: 767px)").matches
  || window.matchMedia("(display-mode: standalone)").matches;

// On phones open pages in the same tab (back works); on PC keep the new-tab behaviour.
export const openPage = (url) => { if (isPhone()) window.location.assign(url); else window.open(url, "_blank", "noopener"); };

export const goBack = (fallback = "/dashboard?panel=order_register") => {
  const sameSite = document.referrer && new URL(document.referrer).origin === window.location.origin;
  if (window.history.length > 1 && sameSite) window.history.back();
  else window.location.assign(fallback);
};

export const BackBar = ({ title, fallback }) => (
  <div className="sticky top-0 z-30 -mx-4 sm:-mx-6 mb-3 flex items-center gap-2 border-b border-slate-200 bg-white/95 px-3 py-2 backdrop-blur"
       style={{ paddingTop: "max(0.5rem, env(safe-area-inset-top))" }} data-testid="page-back-bar">
    <button type="button" onClick={() => goBack(fallback)} data-testid="page-back-btn"
      className="inline-flex items-center gap-1 rounded-full border border-slate-300 bg-white px-3 py-1.5 text-xs font-semibold text-slate-700 active:bg-slate-100">
      <ArrowLeft className="h-4 w-4" /> Back
    </button>
    {title && <span className="min-w-0 flex-1 truncate text-xs font-semibold text-slate-500">{title}</span>}
    <a href="/dashboard" data-testid="page-home-btn" title="Dashboard"
      className="ml-auto inline-flex items-center gap-1 rounded-full border border-slate-300 bg-white px-3 py-1.5 text-xs font-semibold text-slate-700 active:bg-slate-100">
      <Home className="h-4 w-4" /> Home
    </a>
  </div>
);
